import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Button, Image, Spin } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { ChatMedia } from "@rumble-it/common-lib/types/models/ChatConversation.interface";
import { fetchChatMediaBlob } from "../../../../lib/api/resources/chat";

export const ChatMediaAttachment = ({ media }: { media: ChatMedia }) => {
  const isImage = media.mimeType.startsWith("image/");
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  const { data: blob, isLoading } = useQuery({
    queryKey: ["chat", "media", media.id],
    queryFn: () => fetchChatMediaBlob(media.id),
    staleTime: Infinity,
  });

  useEffect(() => {
    if (!blob) return;

    const url = URL.createObjectURL(blob);
    setObjectUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [blob]);

  if (isLoading || !objectUrl) {
    return <Spin size="small" />;
  }

  if (isImage) {
    return (
      <Image
        src={objectUrl}
        alt={media.originalName ?? "Bijlage"}
        style={{ maxWidth: 220, maxHeight: 220, borderRadius: 8 }}
      />
    );
  }

  return (
    <Button
      type="link"
      icon={<PaperClipOutlined />}
      href={objectUrl}
      target="_blank"
      rel="noreferrer"
      style={{ padding: 0 }}
    >
      {media.originalName ?? "Bijlage"}
    </Button>
  );
};
